import React from 'react';

//Componentes
import TableContainer from '../table/TableContainer';

//Estilos
import './ViniedoSearch.css';

function ViniedoSearch({ tableData }) {
    return (
        <div className="viniedo_search-container">
            <TableContainer tableData={tableData} />
        </div>
    );
}

export default ViniedoSearch;
